import {useTranslation} from "react-i18next";
import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {useNavigate} from "react-router-dom";
import {Machine} from "../../../../models/machine.models";

export const MachineTagsManagementAction: React.FC<Machine> = (props) => {
    const navigate = useNavigate();
    const {organizationUnitId, id, friendlyName, tagId, organizationId} = props;
    const {t} = useTranslation();

    const navigateTo = () => {
        if (!!tagId && !!organizationUnitId) {
            const path = `/organization-units/${organizationUnitId}/machines/${id}/tags`;
            const queryParams = `organizationUnitId=${organizationUnitId}&machineName=${friendlyName}&organizationId=${organizationId}`;
            return navigate(`${path}?${queryParams}`);
        }
    };

    return (
        <ListItem disabled={!tagId} onClick={navigateTo}>
            <ListItemText style={{cursor: 'pointer'}}>
                {t('Machine.Actions.ManageTags')}
            </ListItemText>
        </ListItem>
    );
};
